// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkIconStyleGenerator } from "@bg/App/SharedStyles/GeneralStyles";
import { shareLinkStyles } from "@bg/Overrides/Widgets/ProductDetails/ProductDetailsShareLink";
import { css } from "styled-components";

shareLinkStyles.link = {
    link: linkIconStyleGenerator({
        icon: "Share",
        textSize: "13px",
        iconSize: 14,
        additionalTypographyCss: css`
            margin-right: 20px;
            color: #131313 !important;
        `,
        additionalIconCss: css`
            color: #9c822f;
        `,
    }),
};
shareLinkStyles.printLink = linkIconStyleGenerator({
    icon: "Print",
    textSize: "13px",
    iconSize: 14,
    additionalTypographyCss: css`
        color: #131313 !important;
    `,
    additionalIconCss: css`
        fill: #9c822f;
    `,
});
